<template>
	<div>
		<el-row>
			<el-col :span="1">
				<img
					@click="get_back_confirmation()"
					width="35px"
					src="../../../assets/icons/Back Arrow.png"
					style="cursor: pointer"
				/>
			</el-col>
			<el-col
				style="
					margin-top: 0px;
					color: #999999;
					margin-left: -10px;
					font-size: 16px;
				"
				:span="10"
			>
				<div @click="get_back_confirmation()">Back</div>
			</el-col>
		</el-row>
		<el-row
			class="project-table01"
			style="margin-top: 20px; border-radius: 12px"
		>
			<el-col :span="24">
				<div ref="scrollableTable" class="scrollable-table">
					<el-table
						style="border-radius: 8px; overflow-y: auto"
						:data="formItems"
						:style="{ height: tableHeight }"
					>
						<el-table-column label="Sr No">
							<template slot-scope="scope">
								<div>
									<el-row>
										<el-col :span="4">
											<div
												@mouseover="show_edit_icon(scope.row)"
												@mouseleave="hide_edit_icon(scope.row)"
											>
												<b
													v-if="!scope.row.showDropdown"
													@mouseleave="hide_edit_icon(scope.row)"
												>
													{{ scope.row.serial_no }}.
													<img
														@click="show_dropdown(scope.row)"
														v-if="scope.row.editable_icon == true"
														width="14px"
														class="mr-5"
														src="../../../assets/icons/EditIcon.png"
													/>
												</b>
												<el-select
													v-if="scope.row.showDropdown"
													style="margin-top: 10px; width: 100%"
													class="select"
													v-model="scope.row.serial_no"
													filterable
													placeholder="Select"
													@visible-change="
														change_serial_number(
															scope.row,
															scope.row.$index,
															$event
														)
													"
												>
													<el-option
														v-for="(itemxx, key) in serialNumberItems"
														:key="key"
														:label="itemxx.name"
														:value="itemxx.value"
													>
													</el-option>
												</el-select>
											</div>
										</el-col>
										<el-col
											class="ml-2 mt-1"
											v-if="scope.row.showDropdown"
											:span="2"
										>
											<el-button
												@click="
													cancel_change_serial_number(scope.row, scope.$index)
												"
												size="mini"
												icon="el-icon-close"
												style="
													border-radius: 12px;
													color: red;
													border-color: red;
												"
											></el-button>
										</el-col>
										<el-col
											class="ml-3 mt-1"
											v-if="scope.row.showDropdown"
											:span="2"
										>
											<el-button
												@click="
													success_change_serial_number(scope.row, scope.$index)
												"
												size="mini"
												icon="el-icon-check"
												style="
													border-radius: 12px;
													color: green;
													border-color: green;
												"
											></el-button>
										</el-col>
									</el-row>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="Forms"> </el-table-column>
					</el-table>
				</div>
			</el-col>
		</el-row>
		<div style="display: flex; align-items: center"></div>
		<el-row>
			<el-col :span="2" :offset="20">
				<el-button
					style="margin-top: 10px; margin-bottom: -20px"
					class="button-class-white2"
					@click="get_back_confirmation()"
					>Cancel</el-button
				>
			</el-col>
			<el-col :span="2">
				<el-button
					@click="set_forms_with_corrected_slno()"
					style="margin-top: -10px; width: 100px"
					class="button-class"
					>Update</el-button
				>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import formBuilderServices from "../../../services/formBuilderServices";

export default {
	props: { storeFormObj: Object, show_order_page: Boolean },
	data: () => ({
		formItems: [],
		serialNumberItems: [],
		minHeight: 300, // Minimum height for the table
		maxHeight: 600,
		allFormItems: [],
	}),
	mounted() {
		this.get_api();
	},
	computed: {
		tableHeight() {
			const windowHeight = window.innerHeight;
			let tableHeight = windowHeight - 200;
			tableHeight = Math.max(
				this.minHeight,
				Math.min(this.maxHeight, tableHeight)
			);
			return `${tableHeight}px`;
		},
	},
	methods: {
		get_api() {
			formBuilderServices
				.listFormsByCategoryId(this.storeFormObj.category_id)
				.then((res) => {
					this.allFormItems = JSON.parse(res.data);
					this.formItems = JSON.parse(res.data);
					let serialNumberItems = [];
					for (let i = 0; i < this.formItems.length; i++) {
						serialNumberItems.push({ name: i + 1, value: i + 1 });
					}
					this.serialNumberItems = serialNumberItems;
					for (let i = 0; i < this.formItems.length; i++) {
						this.formItems[i].serial_no_selection = "";
					}
					this.formItems = this.formItems.filter((item) =>
						this.storeFormObj.form.includes(item.id)
					);
					console.log("this.formItems", this.formItems, this.storeFormObj);
				});
		},
		set_forms_with_corrected_slno() {
			this.formItems.sort((a, b) => a.serial_no - b.serial_no);
			this.$emit(
				"set_serial_no",
				this.formItems,
				this.storeFormObj,
				this.allFormItems
			);
		},
		cancel_change_serial_number(item, idx) {
			this.$set(item, "showDropdown", false);
			this.$set(item, "showEditIcon", false);
			item.serial_no = item.old_serial_no;
			return item;
		},
		success_change_serial_number(item, idx) {
			console.log(idx, "idx");
			this.$set(item, "showDropdown", false);
			this.$set(item, "showEditIcon", false);
			let arr1 = this.formItems.splice(idx, 1);
			this.insertArrayAt(this.formItems, item.serial_no - 1, arr1);
			this.formItems.forEach((el, index) => {
				el.serial_no = index + 1;
			});
			return item;
		},
		insertArrayAt(array, index, arrayToInsert) {
			Array.prototype.splice.apply(array, [index, 0].concat(arrayToInsert));
			return array;
		},
		change_serial_number(item, idx, event) {
			if (event == true) item.old_serial_no = item.serial_no;
			this.$forceUpdate();
			return item;
		},
		show_edit_icon(item) {
			this.$set(item, "editable_icon", true);
			return item;
		},
		hide_edit_icon(item) {
			this.$set(item, "editable_icon", false);
			return item;
		},
		show_dropdown(item) {
			item.old_serial_no = item.serial_no;
			this.$set(item, "showDropdown", true);
			return item;
		},
		get_back_confirmation() {
			this.$emit("cancel");
		},
	},
};
</script>

<style>
.hide-overflow {
	overflow: hidden;
	overflow-y: hidden;
	overflow-x: hidden;
}
.el-dialog__body {
	overflow: hidden !important;
	overflow-y: hidden;
	overflow-x: hidden;
}
.scrollable-table .el-table__header-wrapper {
	position: sticky;
	top: 0;
	z-index: 1;
	background-color: #fff; /* Adjust background color as needed */
}
</style>
